module.exports = __webpack_public_path__ + "img/teacher.2e24f874.svg";